import isComponent from './isComponent';
/**
 * Very similar to isComponent, but include the storybook check, and is a typescript typeguard
 */
export default ((element, componentType) => {
  if (element.type &&
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (element === null || element === void 0 ? void 0 : element.type.displayName) === 'MDXCreateElement') {
    if (element.props.originalType.typeRef == componentType) {
      return true;
    }
  }
  if (isComponent(element, componentType)) {
    return true;
  }
  return false;
});